import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

const AgencyContact = (props) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      email,
      fax,
      phone,
      website,
    },
    errors,
    handlers,
  } = agencyFormPayload

  return (
    <DashboardModule title="Contact">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.email} label="* Primary Email">
            <input name="email" value={email} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.phone} label="* Primary Phone" marginTop={['large', 0]}>
            <input name="phone" value={phone} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.website} label="* Agency Website">
            <input name="website" value={website} type="text" {...handlers} />
          </Form.Field>

          <Form.Field label="Fax" marginTop={['large', 0]}>
            <input name="fax" value={fax} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

AgencyContact.propTypes = {
  agencyFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      email: PropTypes.string.isRequired,
      fax: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      website: PropTypes.string.isRequired,
    }),
    errors: PropTypes.object,
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default AgencyContact
